import { render, staticRenderFns } from "./WidgetSmallParcelPendingApproval.vue?vue&type=template&id=52cb6cab"
import script from "./WidgetSmallParcelPendingApproval.vue?vue&type=script&lang=js"
export * from "./WidgetSmallParcelPendingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports